<script>
import MainNav from './MainNav.vue'
import MainNavItem from './MainNavItem.vue'
import PageHeaderSearchForm from './PageHeaderSearchForm.vue'

export default {
  name: 'PageHeader',

  components: {
    MainNavItem,
    MainNav,
    PageHeaderSearchForm,
  },

  props: {
    logoSrc: String,
    logoAlt: String,
    logoHref: String,

    mainNavItems: Array,
    supportNavItems: Array,

    navToggleCollapsedLabel: String,
    navToggleExpandedLabel: String,
    searchInputLabel: String,
    searchButtonLabel: String,
  },

  data() {
    return {
      navExpanded: false,
      searchExpanded: false,
      searchFormId: 'page-header-search-form',
      dropdownOpenId: null,
    }
  },

  computed: {
    navToggleLabel () {
      return this.navExpanded ? this.navToggleExpandedLabel : this.navToggleCollapsedLabel
    },
    navToggleAriaExpanded () {
      return this.navExpanded ? 'true' : 'false'
    },
    navToggleIcon () {
      return this.navExpanded ? 'fa-xmark' : 'fa-bars'
    },
    pageHeaderClassName () {
      return {
        'page-header': true,
        'page-header--expanded': this.navExpanded,
      }
    },
    searchFormClassName () {
      return {
        'page-header__search-form': true,
        'page-header__search-form--expanded': this.searchExpanded,
      }
    },
    searchToggleAriaExpanded () {
      return this.searchExpanded ? 'true' : 'false'
    },
  },

  methods: {
    toggleNav () {
      this.navExpanded = !this.navExpanded
    },
    toggleSearch () {
      this.searchExpanded = !this.searchExpanded

      this.$nextTick(() => {
        if (this.searchExpanded) {
          const el = document.getElementById(this.searchFormId)
          const input = el.querySelector('input')
          input.focus()
        }
      })
    },
    openDropdown (id) {
      this.dropdownOpenId = id
    },
    closeDropdown () {
      this.dropdownOpenId = null
    }
  },
}
</script>

<template>
  <div :class="pageHeaderClassName">
    <div class="page-header__masthead">
      <div class="page-header__masthead-container container">
        <a
          :href="logoHref"
          class="page-header__logo"
        >
          <img
            class="page-header__logo-img"
            :src="logoSrc"
            width="165"
            height="40"
            :alt="logoAlt"
          />
        </a>

        <button
          class="page-header__nav-toggle"
          type="button"
          aria-controls="nav-collapsible-area"
          :aria-expanded="navToggleAriaExpanded"
          @click="toggleNav"
        >
          {{ navToggleLabel }}
          <i :class="`far fa-fw ${navToggleIcon}`"></i>
        </button>

        <nav class="page-header__support-nav">
          <main-nav
            :nav-items="supportNavItems"
            theme="dark"
            dropdown-theme="light"
            :dropdown-open-id="dropdownOpenId"
            @dropdown-opened="openDropdown"
            @dropdown-closed="closeDropdown"
          />
        </nav>

        <button
          class="page-header__search-toggle"
          type="button"
          :aria-controls="searchFormId"
          :aria-expanded="searchToggleAriaExpanded"
          @click="toggleSearch"
        >
          {{ searchButtonLabel }}
          <i class="far fa-search"></i>
        </button>
      </div>
    </div>

    <div
      id="nav-collapsible-area"
      class="page-header__main-nav-area"
    >
      <div class="container">
        <nav class="page-header__main-nav">
          <main-nav
            :nav-items="mainNavItems"
            :dropdown-open-id="dropdownOpenId"
            @dropdown-opened="openDropdown"
            @dropdown-closed="closeDropdown"
          />

          <div class="page-header__support-nav page-header__support-nav--header-collapsible">
            <main-nav
              :nav-items="supportNavItems"
              :dropdown-open-id="dropdownOpenId"
              @dropdown-opened="openDropdown"
              @dropdown-closed="closeDropdown"
            />
          </div>
        </nav>

        <div
          :class="searchFormClassName"
          :id="searchFormId"
        >
          <PageHeaderSearchForm
            search-url="/search"
            :search-button-label="searchButtonLabel"
            :search-input-label="searchInputLabel"
          />
        </div>
      </div>
    </div>
  </div>
</template>
